import { Box, IconButton, Stack, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useState } from "react";
import { ImagePreviewModal } from "@components/OrderTrackingFileList/PreviewModals";
import dayjs from "dayjs";

interface ImageBoxProps {
  testId?: string;
  fileName: string;
  url: string;
  onDelete?: () => void;
}

const ImageBox = (props: ImageBoxProps): JSX.Element => {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <>
      <Box
        sx={{
          position: "relative",
          height: 240,
          backgroundColor: "divider",
        }}
      >
        {/* Filename Overlay */}
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            position: "absolute",
            top: 0,
            left: 0,
            width: 1,
            padding: 1,
            zIndex: 5,
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            color: "primary.contrastText",
          }}
        >
          <Typography noWrap>{props.fileName}</Typography>
          {props.onDelete && (
            <IconButton color="inherit" onClick={props.onDelete} size="small">
              <DeleteIcon />
            </IconButton>
          )}
        </Stack>
        {/* Image */}
        <Box
          component="img"
          src={props.url}
          alt="Uploaded"
          onClick={() => setModalOpen(true)}
          data-testid={props.testId}
          sx={{
            cursor: "pointer",
            height: 1,
            width: 1,
            objectFit: "contain",
          }}
        />
      </Box>
      <ImagePreviewModal
        title={props.fileName}
        alt={props.fileName}
        src={props.url}
        createdAt={dayjs()}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </>
  );
};
export default ImageBox;
